interface SocialPixelParams {
	gclid?: string;
	wbraid?: string;
	gbraid?: string;
	fbclid?: string;
	ttclid?: string;
	scclid?: string;
	twclid?: string;
}

export function trackSocialPixels() {
	// Get URL parameters
	const urlParams = new URLSearchParams(window.location.search);

	// Define the parameters we want to track
	const paramKeys = ['gclid', 'wbraid', 'gbraid', 'fbclid', 'ttclid', 'scclid', 'twclid'];

	// Get existing cookie data
	const existingCookie = document.cookie.split('; ').find(row => row.startsWith('pagePilotSocialPixels='));

	let existingData: SocialPixelParams = {};

	if (existingCookie) {
		try {
			existingData = JSON.parse(decodeURIComponent(existingCookie.split('=')[1]));
		} catch (e) {
			console.error('Error parsing existing cookie:', e);
		}
	}

	// Collect new parameters
	const newParams: SocialPixelParams = {};
	let hasNewParams = false;

	paramKeys.forEach(key => {
		const value = urlParams.get(key);
		if (value && !existingData[key as keyof SocialPixelParams]) {
			newParams[key as keyof SocialPixelParams] = value;
			hasNewParams = true;
		}
	});

	// If we have new parameters, update the cookie
	if (hasNewParams) {
		const updatedData = { ...existingData, ...newParams };

		// Set cookie with domain attribute to make it accessible across subdomains
		const cookieValue = encodeURIComponent(JSON.stringify(updatedData));
		const domain = window.location.hostname.split('.').slice(-2).join('.');

		document.cookie = `pagePilotSocialPixels=${cookieValue}; path=/; domain=.${domain}; max-age=31536000; SameSite=None; Secure`;
	}

	return { ...existingData, ...newParams };
}
